import { put, select } from "redux-saga/effects";

import type { UpdatePageSettings2Input } from "../../../gql/graphql";
import { getRailIsEnabled } from "../../sidebar/sidebarReducer";
import { requestSavePageSettings } from "../pageSettingsActions";

export function* updateSidebarPageSettings() {
  const pinned: ReturnType<typeof getRailIsEnabled> =
    yield select(getRailIsEnabled);

  const input: UpdatePageSettings2Input = {
    sidebar: {
      pinned,
    },
  };

  yield put(requestSavePageSettings(input));
}
